// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../css/variables.css\"","BodyBg":"#F8F8FA","BASE_COLOR":"#0c8eff"};